import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import logo from "assets/carousel/logo.png";
import step1 from "assets/carousel/step1-login.png";
import step2 from "assets/carousel/step2-accounts.png";
import step3 from "assets/carousel/step3-rules.png";

// 4-slide "How Moujib works" walkthrough, ported from the standalone carousel.
// The markup is authored at a fixed 1080px stage so the orange hotspot overlays
// stay pixel-aligned over the screenshots; we scale the whole stage to fit its
// container responsively (see the useLayoutEffect below).
const COUNT = 4;
const STAGE_WIDTH = 1080;

const SLIDES_HTML = `<!-- SLIDE 1 — COVER -->
      <section data-screen-label="01 Cover" style="flex:0 0 25%; height:100%; position:relative; overflow:hidden; background:linear-gradient(157deg,#1D4ED8 0%,#2563EB 52%,#3B82F6 100%); color:#fff; padding:92px; display:flex; flex-direction:column;">
        <div style="position:absolute; right:-160px; top:-160px; width:560px; height:560px; border-radius:50%; background:rgba(255,255,255,.07);"></div>
        <div style="position:absolute; left:-120px; bottom:-180px; width:460px; height:460px; border-radius:50%; background:rgba(255,255,255,.05);"></div>

        <div style="display:inline-flex; align-self:flex-start; align-items:center; background:#fff; padding:20px 32px; border-radius:22px; box-shadow:0 14px 38px rgba(0,0,0,.18); position:relative;">
          <img src="__LOGO__" alt="Moujib" style="display:block; height:74px; width:auto;">
        </div>

        <div style="margin-top:auto; position:relative;">
          <div style="display:inline-block; font-size:18px; font-weight:700; letter-spacing:3px; text-transform:uppercase; opacity:.85; padding:9px 18px; border:1.5px solid rgba(255,255,255,.4); border-radius:999px; margin-bottom:34px; white-space:nowrap;">Smart comment moderation</div>
          <h1 style="font-size:92px; line-height:1.02; font-weight:800; letter-spacing:-2.5px; margin:0;">Clean your page<br>in 3 clicks.</h1>
          <p style="font-size:33px; line-height:1.4; font-weight:500; opacity:.92; margin:30px 0 0; max-width:740px;">Protect your brand and hide harmful comments — in just <b style="font-weight:800;">3 easy steps</b>.</p>
        </div>

        <div style="margin-top:54px; display:flex; align-items:center; gap:14px; font-size:26px; font-weight:800; position:relative;">
          <span>Swipe to see how</span>
          <span style="display:inline-flex; animation:mj-swipe 1.3s ease-in-out infinite;">
            <svg width="42" height="28" viewBox="0 0 42 28" fill="none"><path d="M3 14H35" stroke="#fff" stroke-width="5" stroke-linecap="round"></path><path d="M25 4L37 14L25 24" stroke="#fff" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          </span>
        </div>
      </section>

      <!-- SLIDE 2 — STEP 1 -->
      <section data-screen-label="02 Connect to Moujib" style="flex:0 0 25%; height:100%; position:relative; overflow:hidden; background:linear-gradient(180deg,#FFFFFF 0%,#EEF4FF 100%); color:#0F172A; padding:80px 80px 0; display:flex; flex-direction:column;">
        <div style="display:flex; align-items:center; gap:18px;">
          <span style="font-size:22px; font-weight:800; color:#fff; background:#2563EB; padding:8px 18px; border-radius:999px; letter-spacing:1px; white-space:nowrap;">STEP 1</span>
          <span style="font-size:22px; font-weight:700; color:#94A3B8; letter-spacing:2px; white-space:nowrap;">01 / 03</span>
        </div>
        <h2 style="font-size:62px; line-height:1.05; font-weight:800; letter-spacing:-1.5px; margin:24px 0 0;">Connect to Moujib</h2>
        <p style="font-size:30px; line-height:1.4; font-weight:500; color:#5B6B86; margin:18px 0 0; max-width:820px;">Sign in your way — Facebook, Google or email.</p>

        <div style="flex:1; position:relative; display:flex; align-items:center; justify-content:center; margin-top:28px;">
          <div style="position:relative; border-radius:24px 24px 0 0; overflow:hidden; box-shadow:0 -2px 0 #E6ECF5, 0 30px 70px -24px rgba(37,99,235,.45); border:1px solid #E6ECF5; border-bottom:none; background:#fff;">
            <div style="height:46px; background:#F1F5FB; display:flex; align-items:center; gap:8px; padding:0 20px; border-bottom:1px solid #E6ECF5;">
              <span style="width:12px;height:12px;border-radius:50%;background:#FF5F57;"></span>
              <span style="width:12px;height:12px;border-radius:50%;background:#FEBC2E;"></span>
              <span style="width:12px;height:12px;border-radius:50%;background:#28C840;"></span>
              <span style="margin-left:16px; background:#fff; border:1px solid #E2E8F0; border-radius:8px; font-size:16px; color:#64748B; padding:5px 16px; font-weight:600;">app.moujib.com</span>
            </div>
            <div style="position:relative;">
              
              <!-- hotspot around all sign-in options -->
              <div style="position: absolute; left: 196px; top: 520px; width: 385px; height: 270px; transform: translate(-50%,-50%); border: 5px solid #FF5C16; border-radius: 18px; animation: mj-pulse 1.6s ease-out infinite"></div>
            <img src="__STEP1__" width="392" height="820" style="display:block;" alt="Moujib login"></div>
          </div>
          <!-- arrow + label -->
          <div style="position:absolute; right:50px; top:56%; display:flex; flex-direction:column; align-items:center; gap:10px; animation:mj-floatLeft 1.4s ease-in-out infinite;">
            <div style="background:#FF5C16; color:#fff; font-weight:800; font-size:25px; padding:12px 22px; border-radius:14px; box-shadow:0 12px 28px rgba(255,92,22,.42); white-space:nowrap;">Pick any option</div>
            <svg width="150" height="64" viewBox="0 0 150 64" fill="none" style="transform:rotate(8deg);"><path d="M138 10 C70 14, 30 30, 10 52" stroke="#FF5C16" stroke-width="11" stroke-linecap="round"></path><path d="M30 36 L8 54 L34 60" stroke="#FF5C16" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          </div>
        </div>
      </section>

      <!-- SLIDE 3 — STEP 2 -->
      <section data-screen-label="03 Connect your page" style="flex:0 0 25%; height:100%; position:relative; overflow:hidden; background:linear-gradient(180deg,#FFFFFF 0%,#EEF4FF 100%); color:#0F172A; padding:80px 80px 0; display:flex; flex-direction:column;">
        <div style="display:flex; align-items:center; gap:18px;">
          <span style="font-size:22px; font-weight:800; color:#fff; background:#2563EB; padding:8px 18px; border-radius:999px; letter-spacing:1px; white-space:nowrap;">STEP 2</span>
          <span style="font-size:22px; font-weight:700; color:#94A3B8; letter-spacing:2px; white-space:nowrap;">02 / 03</span>
        </div>
        <h2 style="font-size:62px; line-height:1.05; font-weight:800; letter-spacing:-1.5px; margin:24px 0 0;">Connect your Page<br>or Instagram</h2>
        <p style="font-size:30px; line-height:1.4; font-weight:500; color:#5B6B86; margin:18px 0 0; max-width:820px;">Link the account you want Moujib to keep clean.</p>

        <div style="flex:1; position:relative; display:flex; align-items:center; justify-content:center;">
          <div style="position:relative; border-radius:22px; overflow:hidden; box-shadow:0 30px 70px -24px rgba(37,99,235,.45); border:1px solid #E6ECF5; background:#fff; width:920px;">
            <div style="height:46px; background:#F1F5FB; display:flex; align-items:center; gap:8px; padding:0 20px; border-bottom:1px solid #E6ECF5;">
              <span style="width:12px;height:12px;border-radius:50%;background:#FF5F57;"></span>
              <span style="width:12px;height:12px;border-radius:50%;background:#FEBC2E;"></span>
              <span style="width:12px;height:12px;border-radius:50%;background:#28C840;"></span>
              <span style="margin-left:16px; background:#fff; border:1px solid #E2E8F0; border-radius:8px; font-size:16px; color:#64748B; padding:5px 16px; font-weight:600;">app.moujib.com/accounts</span>
            </div>
            <div style="position:relative;">
              <img src="__STEP2__" width="918" height="183" style="display:block;" alt="Connect accounts">
              <!-- hotspot around connect buttons -->
              <div style="position: absolute; left: 774px; top: 38px; width: 282px; height: 52px; transform: translate(-50%,-50%); border: 5px solid #FF5C16; border-radius: 16px; animation: mj-pulse 1.6s ease-out infinite"></div>
            </div>
          </div>
          <!-- arrow + label coming from below -->
          <div style="position:absolute; right:120px; bottom:88px; display:flex; flex-direction:column; align-items:center; gap:8px; animation:mj-floatUp 1.4s ease-in-out infinite;">
            <svg width="80" height="120" viewBox="0 0 80 120" fill="none"><path d="M40 112 C40 60, 24 30, 56 12" stroke="#FF5C16" stroke-width="11" stroke-linecap="round"></path><path d="M38 24 L58 8 L66 32" stroke="#FF5C16" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            <div style="background:#FF5C16; color:#fff; font-weight:800; font-size:25px; padding:12px 22px; border-radius:14px; box-shadow:0 12px 28px rgba(255,92,22,.42); white-space:nowrap;">Pick your account</div>
          </div>
        </div>
      </section>

      <!-- SLIDE 4 — STEP 3 -->
      <section data-screen-label="04 Choose what to hide" style="flex:0 0 25%; height:100%; position:relative; overflow:hidden; background:linear-gradient(180deg,#FFFFFF 0%,#EEF4FF 100%); color:#0F172A; padding:80px 80px 0; display:flex; flex-direction:column;">
        <div style="display:flex; align-items:center; gap:18px;">
          <span style="font-size:22px; font-weight:800; color:#fff; background:#2563EB; padding:8px 18px; border-radius:999px; letter-spacing:1px; white-space:nowrap;">STEP 3</span>
          <span style="font-size:22px; font-weight:700; color:#94A3B8; letter-spacing:2px; white-space:nowrap;">03 / 03</span>
        </div>
        <h2 style="font-size:62px; line-height:1.05; font-weight:800; letter-spacing:-1.5px; margin:24px 0 0;">Choose what to hide</h2>
        <p style="font-size:30px; line-height:1.4; font-weight:500; color:#5B6B86; margin:18px 0 0; max-width:880px;">Bad words, hate speech, spam… switch on what to block. One click each.</p>

        <div style="flex:1; position:relative; display:flex; align-items:center; justify-content:center;">
          <div style="position:relative; border-radius:22px; overflow:hidden; box-shadow:0 30px 70px -24px rgba(37,99,235,.45); border:1px solid #E6ECF5; background:#fff; width:920px;">
            <div style="height:46px; background:#F1F5FB; display:flex; align-items:center; gap:8px; padding:0 20px; border-bottom:1px solid #E6ECF5;">
              <span style="width:12px;height:12px;border-radius:50%;background:#FF5F57;"></span>
              <span style="width:12px;height:12px;border-radius:50%;background:#FEBC2E;"></span>
              <span style="width:12px;height:12px;border-radius:50%;background:#28C840;"></span>
              <span style="margin-left:16px; background:#fff; border:1px solid #E2E8F0; border-radius:8px; font-size:16px; color:#64748B; padding:5px 16px; font-weight:600;">app.moujib.com/rules</span>
            </div>
            <div style="position:relative;">
              <img src="__STEP3__" width="918" height="377" style="display:block;" alt="Moderation rules">
              <!-- hotspot on Bad Words toggle -->
              <div style="position:absolute; left:29.6%; top:24.5%; width:74px; height:46px; transform:translate(-50%,-50%); border:5px solid #FF5C16; border-radius:999px; animation:mj-pulse 1.6s ease-out infinite;"></div><div style="position:absolute; left:29.6%; top:24.5%; width:74px; height:46px; transform:translate(-50%,-50%); border:5px solid #FF5C16; border-radius:999px; animation:mj-pulse 1.6s ease-out infinite;"></div><div style="position: absolute; left: 577px; top: 92px; width: 74px; height: 46px; transform: translate(-50%,-50%); border: 5px solid #FF5C16; border-radius: 999px; animation: mj-pulse 1.6s ease-out infinite"></div>
            </div>
          </div>
          <!-- arrow + label -->
          <div style="position:absolute; left:96px; bottom:96px; display:flex; flex-direction:column; align-items:center; gap:8px; animation:mj-floatUp 1.4s ease-in-out infinite;">
            <svg width="120" height="110" viewBox="0 0 120 110" fill="none"><path d="M14 100 C20 50, 60 30, 104 16" stroke="#FF5C16" stroke-width="11" stroke-linecap="round"></path><path d="M82 8 L108 14 L96 38" stroke="#FF5C16" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            <div style="background:#FF5C16; color:#fff; font-weight:800; font-size:25px; padding:12px 22px; border-radius:14px; box-shadow:0 12px 28px rgba(255,92,22,.42); white-space:nowrap;">Toggle it on</div>
          </div>
        </div>
      </section>`
  .replace(/__LOGO__/g, logo)
  .replace(/__STEP1__/g, step1)
  .replace(/__STEP2__/g, step2)
  .replace(/__STEP3__/g, step3);

const KEYFRAMES = `
  .mj-stage * { box-sizing: border-box; }
  @keyframes mj-pulse {
    0%   { box-shadow: 0 0 0 0 rgba(255,92,22,.55); }
    70%  { box-shadow: 0 0 0 18px rgba(255,92,22,0); }
    100% { box-shadow: 0 0 0 0 rgba(255,92,22,0); }
  }
  @keyframes mj-floatUp   { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-14px); } }
  @keyframes mj-floatLeft { 0%,100% { transform: translateX(0); } 50% { transform: translateX(-14px); } }
  @keyframes mj-floatDown { 0%,100% { transform: translateY(0); } 50% { transform: translateY(14px); } }
  @keyframes mj-swipe     { 0%,100% { transform: translateX(0); opacity: .85; } 50% { transform: translateX(16px); opacity: 1; } }
`;

const MoujibCarousel: React.FC = () => {
  const [i, setI] = useState(0);
  const [scale, setScale] = useState(0);
  const [height, setHeight] = useState(0);

  const containerRef = useRef<HTMLDivElement>(null);
  const stageRef = useRef<HTMLDivElement>(null);

  const go = useCallback((n: number) => setI(((n % COUNT) + COUNT) % COUNT), []);
  const next = useCallback(() => setI((p) => (p + 1) % COUNT), []);
  const prev = useCallback(() => setI((p) => (p - 1 + COUNT) % COUNT), []);

  // Scale the fixed-width stage to fit the responsive container.
  useLayoutEffect(() => {
    const measure = () => {
      const container = containerRef.current;
      const stage = stageRef.current;
      if (!container || !stage) return;
      const s = container.clientWidth / STAGE_WIDTH;
      setScale(s);
      setHeight(stage.offsetHeight * s); // offsetHeight is pre-transform
    };
    measure();
    const ro = new ResizeObserver(measure);
    if (containerRef.current) ro.observe(containerRef.current);
    return () => ro.disconnect();
  }, []);

  // Swipe (pointer) navigation on the square viewport.
  const downX = useRef<number | null>(null);
  const onPointerDown = (e: React.PointerEvent) => {
    downX.current = e.clientX;
  };
  const onPointerUp = (e: React.PointerEvent) => {
    if (downX.current == null) return;
    const dx = e.clientX - downX.current;
    downX.current = null;
    if (Math.abs(dx) > 60) (dx < 0 ? next() : prev());
  };

  // Arrow-key navigation, scoped to focus so it never hijacks page scroll.
  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "ArrowRight") next();
    if (e.key === "ArrowLeft") prev();
  };

  // Gentle auto-advance; the timer resets on every slide change (incl. manual).
  useEffect(() => {
    const t = setInterval(next, 5000);
    return () => clearInterval(t);
  }, [i, next]);

  return (
    <section
      id="walkthrough"
      className="py-24 bg-gradient-to-b from-background to-secondary/20 relative overflow-hidden"
    >
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-14">
          <h2 className="text-4xl lg:text-5xl font-heading font-bold mb-4">
            See how it{" "}
            <span className="bg-gradient-primary bg-clip-text text-transparent">
              actually works
            </span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Connect, choose what to hide, and let Moujib keep your page clean —
            swipe through the 3 steps.
          </p>
        </div>

        <style>{KEYFRAMES}</style>

        <div
          ref={containerRef}
          className="mj-stage"
          style={{
            width: "100%",
            maxWidth: 760,
            margin: "0 auto",
            position: "relative",
            height: height || undefined,
            fontFamily: "Manrope, -apple-system, BlinkMacSystemFont, sans-serif",
            userSelect: "none",
          }}
        >
          <div
            ref={stageRef}
            style={{
              width: STAGE_WIDTH,
              position: "absolute",
              top: 0,
              left: 0,
              transformOrigin: "top left",
              transform: scale ? `scale(${scale})` : undefined,
              visibility: scale ? "visible" : "hidden",
            }}
          >
            {/* ===== SQUARE VIEWPORT ===== */}
            <div
              tabIndex={0}
              onKeyDown={onKeyDown}
              onPointerDown={onPointerDown}
              onPointerUp={onPointerUp}
              style={{
                position: "relative",
                width: STAGE_WIDTH,
                height: STAGE_WIDTH,
                overflow: "hidden",
                borderRadius: 8,
                background: "#0B1B3F",
                outline: "none",
                cursor: "grab",
              }}
            >
              <div
                style={{
                  display: "flex",
                  width: "400%",
                  height: "100%",
                  transition: "transform .45s cubic-bezier(.6,.05,.1,1)",
                  transform: `translateX(-${i * 25}%)`,
                }}
                dangerouslySetInnerHTML={{ __html: SLIDES_HTML }}
              />

              <button
                onClick={prev}
                aria-label="Previous"
                style={{
                  position: "absolute",
                  left: 22,
                  top: "50%",
                  transform: "translateY(-50%)",
                  width: 64,
                  height: 64,
                  borderRadius: "50%",
                  border: "none",
                  background: "rgba(255,255,255,.92)",
                  boxShadow: "0 8px 24px rgba(0,0,0,.22)",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                  <path d="M15 5l-7 7 7 7" stroke="#0F172A" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <button
                onClick={next}
                aria-label="Next"
                style={{
                  position: "absolute",
                  right: 22,
                  top: "50%",
                  transform: "translateY(-50%)",
                  width: 64,
                  height: 64,
                  borderRadius: "50%",
                  border: "none",
                  background: "rgba(255,255,255,.92)",
                  boxShadow: "0 8px 24px rgba(0,0,0,.22)",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                  <path d="M9 5l7 7-7 7" stroke="#0F172A" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>

              <div
                style={{
                  position: "absolute",
                  right: 26,
                  top: 26,
                  background: "rgba(11,27,63,.55)",
                  color: "#fff",
                  fontSize: 22,
                  fontWeight: 800,
                  padding: "8px 18px",
                  borderRadius: 999,
                  backdropFilter: "blur(4px)",
                }}
              >
                {i + 1} / {COUNT}
              </div>
            </div>

            {/* ===== DOTS ===== */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 14, padding: "30px 0 6px" }}>
              {Array.from({ length: COUNT }).map((_, k) => (
                <button
                  key={k}
                  onClick={() => go(k)}
                  aria-label={`Go to slide ${k + 1}`}
                  style={{
                    border: "none",
                    cursor: "pointer",
                    padding: 0,
                    height: 14,
                    borderRadius: 999,
                    transition: "all .3s ease",
                    width: k === i ? 40 : 14,
                    background: k === i ? "#2563EB" : "#CBD5E1",
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MoujibCarousel;
